import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import hospitalReducer from './hospitalSlice';
import cityReducer from './citySlice';
import languageReducer from './languageSlice';
import languageTierReducer from './languageTierSlice';

import stateReducer from './stateSlice';
import interpreterReducer from './interpreterSlice';
import vendorReducer from './vendorSlice';
import adminReducer from './adminSlice';
import profileReducer from './profileSlice';
import availibilityReducer from './availibilitySlice';

// crm slices imports

import typesReducer from './typeSlice';
import accountReducer from './accountSlice';
import templateReducer from './templateSlice';
import staffReducer from './staffSlice';
import subUserReducer from './subUserSlice';
import departmentReducer from './departmentsSlice';
import facilityReducer from './facilitiesSlice'; 
import appointmentReducer from './appointmentSlice';
import appointmentRequestReducer from './appointmentRequestSlice';
import languageRequestReducer from './languageRequestSlice';
import dashboardReducer from './dashboardSlice'; 
import permissionReducer from './permissionGroupSlice'; 
import appReducer from './appSlice'; 
import extensionsReducer from './extensionsSlice'; 
import actionButtonReducer from './actionButtonSlice'; 
import inviteInterpreterReducer from './inviteInterpreterSlice';
import interviewInvitesReducer from './interviewInviteSlice';
import invoiceReducer from './invoiceSlice';
import paymentReducer from './paymentSlice';
import paymentStatementReducer from './paymentStatementSlice';
import timesheetReducer from './timesheetSlice';
import interpretertimesheetReducer from './interpreter/interpreterTimesheetSlice';
import chatReducer from './chatSlice';
import clienttimesheetReducer from './clientTimesheetSlice';

import mainAccountDashboardReducer from './mainAccount/dashboardSlice';
import mainSubAccountReducer from './mainAccount/subAccountSlice';      
import mainAccountInvoiceReducer from './mainAccount/mainAccountInvoiceSlice';      
import mainAccountProfileReducer from './mainAccount/mainAccountProfileSlice';      
import mainAccountAppointmentReducer from './mainAccount/mainAccountAppointmentSlice'; 

import interpreterDashboardReducer from './interpreter/dashboardSlice'; 
import interpreterPaymentReducer from './interpreter/paymentSlice';     
import interpreterProfileReducer from './interpreter/profileSlice';      
import interpreterAppointmentReducer from './interpreter/appointmentSlice'; 
// Client Translation Slice
import clientTranslationReducer from './mainAccount/ClientTranslationSlice';
// Interpreter Translation Slice 
import interpreterTranslationReducer from './interpreter/interpreterTranslationSlice';
// admin translation slice 
import translationReducer from './translationSlice';

import clientReducer from "./ClientNameSlice"; 
import translatorReducer from "./TranslatorNameSlice"; 
import inviteTranslatorReducer from './inviteTranslatorSlice';


import iframeReducer  from "./iframeSlice";
import interpreterIframeReducer  from "./interpreter/interpreterIframeSlice";
import requesterIframeReducer  from "./requesterIframeUrlSlice";

export default combineReducers({
    user: userReducer,
    profile: profileReducer,
    hospital: hospitalReducer,
    city: cityReducer,
    language: languageReducer,
    languageTier: languageTierReducer,
    state: stateReducer,
    vendor: vendorReducer, 
    admin: adminReducer,
    availibility: availibilityReducer,

    iframe: iframeReducer,
    interpreterIframe: interpreterIframeReducer,
    requesterIframe: requesterIframeReducer,

    // crm slices
    types: typesReducer,
    accounts: accountReducer,
    templates: templateReducer,
    staff: staffReducer,
    subUser: subUserReducer,
    interpreter: interpreterReducer,
    departments: departmentReducer,
    facilities: facilityReducer,
    appointments: appointmentReducer,
    appointmentRequest: appointmentRequestReducer,
    languageRequest: languageRequestReducer,
    dashboard : dashboardReducer,
    permission : permissionReducer,
    appStates: appReducer,
    actionButton: actionButtonReducer,
    extension: extensionsReducer,
    inviteInterpreters: inviteInterpreterReducer,
    invoices: invoiceReducer,
    interviewInvites: interviewInvitesReducer,
    payments: paymentReducer,
    paymentStatements: paymentStatementReducer,
    timesheet: timesheetReducer,
    chat: chatReducer,
    interpretertimesheet: interpretertimesheetReducer,
    clienttimesheet: clienttimesheetReducer,

    // main account access 
    mainAccountDashboard : mainAccountDashboardReducer,
    mainSubAccounts: mainSubAccountReducer,
    mainAccountInvoice: mainAccountInvoiceReducer,
    mainAccountProfile: mainAccountProfileReducer,
    mainAccountAppointments: mainAccountAppointmentReducer,

    // Interpreter access 
    interpreterDashboard : interpreterDashboardReducer,
    payment: interpreterPaymentReducer,
    interpreterProfile: interpreterProfileReducer,
    interpreterAppointments: interpreterAppointmentReducer,


    clientTranslation: clientTranslationReducer, // Client Translation Slice
    interpreterTranslation: interpreterTranslationReducer, // Interpreter Translation Slice
     translation: translationReducer, // Admin Translation Slice
     clients: clientReducer, // Client Name Slice
     translators: translatorReducer, // Translator Name Slice
      inviteTranslators: inviteTranslatorReducer, // Invite Translator Slice
});
